import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useCart } from "@/contexts/CartContext";
import { formatPrice } from "@/lib/api";

export default function ProductCard({ p, idx = 0 }) {
  const { toggleWishlist, inWishlist } = useCart();
  const img = p.images?.[0];
  const hover = p.images?.[1] || img;
  return (
    <div className="group ja-fade-up" style={{ animationDelay: `${idx * 60}ms` }} data-testid={`product-card-${p.id}`}>
      <Link to={`/product/${p.id}`} className="block relative overflow-hidden bg-white aspect-[4/5]" data-testid={`product-link-${p.id}`}>
        <img src={img} alt={p.name} className="w-full h-full object-cover ja-hover-img" loading="lazy" />
        <img src={hover} alt="" className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700" loading="lazy" aria-hidden />
        {p.is_new && <span className="absolute top-4 left-4 text-[10px] tracking-[0.3em] uppercase bg-black text-white px-2 py-1">New</span>}
        {p.is_best_seller && !p.is_new && <span className="absolute top-4 left-4 text-[10px] tracking-[0.3em] uppercase bg-white px-2 py-1" style={{ color: "var(--ja-black)" }}>Bestseller</span>}
        <button
          onClick={(e) => { e.preventDefault(); toggleWishlist(p.id); }}
          className="absolute top-4 right-4 w-9 h-9 bg-white/90 flex items-center justify-center"
          aria-label="Wishlist"
          data-testid={`wishlist-toggle-${p.id}`}
        >
          <Heart size={15} className={inWishlist(p.id) ? "fill-current" : ""} style={{ color: inWishlist(p.id) ? "var(--ja-gold)" : "var(--ja-black)" }} />
        </button>
      </Link>
      <div className="pt-5 text-center">
        <p className="ja-overline" style={{ color: "var(--ja-muted)" }}>{p.category}</p>
        <Link to={`/product/${p.id}`} className="ja-serif text-lg block mt-1 hover:underline">{p.name}</Link>
        <p className="mt-1 text-sm" style={{ color: "var(--ja-black)" }}>
          {formatPrice(p.price, p.currency)}
          {p.compare_at_price && <span className="line-through ml-2 opacity-50">{formatPrice(p.compare_at_price, p.currency)}</span>}
        </p>
      </div>
    </div>
  );
}
